import { ref } from 'vue';

export interface UseQuickActionsNavigationOptions {
	onExecute?: (index: number) => void;
}

export const useQuickActionsNavigation = (
	options: UseQuickActionsNavigationOptions = {}
) => {
	const selectedItemIndex = ref<number>(-1);
	const itemCount = ref<number>(0);

	const handleKeyDown = (event: KeyboardEvent) => {
		if (event.key === 'ArrowDown') {
			event.preventDefault();
			if (selectedItemIndex.value === -1) {
				selectedItemIndex.value = 0;
			} else {
				selectedItemIndex.value = Math.min(
					selectedItemIndex.value + 1,
					itemCount.value - 1
				);
			}
		} else if (event.key === 'ArrowUp') {
			event.preventDefault();
			if (selectedItemIndex.value > 0) {
				selectedItemIndex.value = selectedItemIndex.value - 1;
			}
		} else if (event.key === 'Enter') {
			event.preventDefault();
			if (selectedItemIndex.value >= 0 && options.onExecute) {
				options.onExecute(selectedItemIndex.value);
			}
		}
	};

	const updateItemCount = (count: number) => {
		itemCount.value = count;
		if (selectedItemIndex.value >= count) {
			selectedItemIndex.value = Math.max(-1, count - 1);
		}
	};

	const resetSelection = () => {
		selectedItemIndex.value = -1;
	};

	return {
		selectedItemIndex,
		itemCount,
		handleKeyDown,
		updateItemCount,
		resetSelection,
	};
};
